"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const types_1 = require("./types");
const files_1 = require("../../../files");
const toMarkdown = (element, context) => {
    var _a, _b, _c, _d;
    const label = ((_a = element.value) === null || _a === void 0 ? void 0 : _a.label) || 'Button';
    if (((_b = element.value) === null || _b === void 0 ? void 0 : _b.actionType) === types_1.ButtonActionType.link) {
        const linkData = element.value.actionData;
        const url = linkData === null || linkData === void 0 ? void 0 : linkData.url;
        if (url) {
            return `[Button: ${label}](${url})`;
        }
    }
    if (((_c = element.value) === null || _c === void 0 ? void 0 : _c.actionType) === types_1.ButtonActionType.file) {
        const fileData = element.value.actionData;
        const url = (fileData === null || fileData === void 0 ? void 0 : fileData.file) &&
            ((_d = context.resolveFileUrl) === null || _d === void 0 ? void 0 : _d.call(context, Object.assign(Object.assign({}, fileData === null || fileData === void 0 ? void 0 : fileData.file), { type: files_1.FileUsageTypeEnum.common })));
        if (url) {
            return `[Button: ${label}](${url})`;
        }
    }
    return `[Button: ${label}]`;
};
exports.toMarkdown = toMarkdown;
